import { render } from "./PureBiddingTable.vue?vue&type=template&id=4f1be571&scoped=true"
import script from "./PureBiddingTable.vue?vue&type=script&lang=js"
export * from "./PureBiddingTable.vue?vue&type=script&lang=js"

import "./PureBiddingTable.vue?vue&type=style&index=0&id=4f1be571&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1be571"]])

export default __exports__